export const SET_NOTIFICATION_FETCH_ENABLED_FLAG = 'SET_NOTIFICATION_FETCH_ENABLED_FLAG';
export function setNotificationFetchEnabled(isNotificationFetchEnabled) {
  return {
    type: SET_NOTIFICATION_FETCH_ENABLED_FLAG,
    payload: {
      isNotificationFetchEnabled,
    },
  };
}
